import http from "./axios";

// 获取熊猫英语跟进老师信息
export const pandaTeacherInfo = ({ phone }) => {
  return http.get("/order/pandaTeacherInfo", {
    phone: phone,
  });
};
